import { ErrorHandlingEffects } from '../../store/effects/error-handling.effects';
import { AuthGuardV2Effects } from './auth-guard';
import { AuthGuardLegacyEffects } from './auth-guard/auth-guard-legacy.effects';
import { WebSocketServiceEffects } from './web-socket/web-socket.effects';

export const servicesEffects = [
	AuthGuardV2Effects,
	AuthGuardLegacyEffects,
	WebSocketServiceEffects,
	ErrorHandlingEffects
];
